import { useEffect, useRef, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Download, QrCode } from "lucide-react";
import { api } from "@/lib/api";

const APP_LINK = `${window.location.origin}/?src=pacco`;
const SITE_LINK = `${window.location.origin}/api/go/sito`;

const QRCard = ({ title, text, link, file, testid, children }) => {
  const wrap = useRef(null);
  const download = () => {
    const canvas = wrap.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = file;
    a.click();
  };
  return (
    <div className="flex flex-col sm:flex-row gap-5 sm:items-center rounded-2xl border border-[#F1ECE7] p-4" data-testid={testid}>
      <div ref={wrap} className="self-start rounded-2xl border border-[#EFE8E2] p-3 bg-white" data-testid={`${testid}-code`}>
        <QRCodeCanvas value={link} size={1024} level="M" marginSize={2} style={{ width: 150, height: 150 }} />
      </div>
      <div className="space-y-3 min-w-0">
        <div className="font-medium text-[#2D2825]">{title}</div>
        <p className="text-sm text-[#5C534E] max-w-md">{text}</p>
        <div className="text-xs text-[#8C7F78] break-all" data-testid={`${testid}-link`}>{link}</div>
        {children}
        <button onClick={download} data-testid={`${testid}-download`}
          className="inline-flex items-center gap-2 rounded-full bg-[#2D2825] text-white text-sm px-5 py-2 hover:bg-[#473f3a] transition-colors">
          <Download size={15} /> Scarica QR code (PNG)
        </button>
      </div>
    </div>
  );
};

export const PackageQR = () => {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/qr-stats").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  return (
    <section className="rounded-2xl border border-[#EAE3DC] bg-white p-5 sm:p-6 mb-6 space-y-4" data-testid="package-qr">
      <div className="flex items-center gap-2">
        <QrCode size={18} className="text-[#C87D75]" />
        <h3 className="font-medium text-[#2D2825]">QR code da stampare</h3>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <QRCard title="QR per i pacchi → app" link={APP_LINK} file="minime-qr-pacchi.png" testid="package-qr-app"
          text="Mettilo nei pacchi: chi lo inquadra arriva all'app e può registrarsi. Scansioni e iscrizioni vengono contate.">
          <div className="flex gap-6 text-sm">
            <div><div className="text-[11px] uppercase tracking-wider text-[#8C7F78]">Scansioni</div><div className="font-serif text-2xl text-[#2D2825]" data-testid="qr-scans">{stats?.scans ?? "—"}</div></div>
            <div><div className="text-[11px] uppercase tracking-wider text-[#8C7F78]">Mamme iscritte</div><div className="font-serif text-2xl text-[#C87D75]" data-testid="qr-signups">{stats?.signups ?? "—"}</div></div>
          </div>
        </QRCard>
        <QRCard title="QR → sito principale" link={SITE_LINK} file="minime-qr-sito.png" testid="package-qr-site"
          text="Porta al negozio www.minimebaby.it: utile per biglietti, vetrine e materiale stampato. Ogni scansione viene contata prima di aprire il sito.">
          <div className="text-sm">
            <div className="text-[11px] uppercase tracking-wider text-[#8C7F78]">Scansioni</div>
            <div className="font-serif text-2xl text-[#2D2825]" data-testid="qr-site-scans">{stats?.site_scans ?? "—"}</div>
          </div>
        </QRCard>
      </div>
    </section>
  );
};
